import DisplayOrdered from "@mapmycustomers/shared/types/base/DisplayOrdered";

const displayOrderComparator = (a: DisplayOrdered, b: DisplayOrdered) =>
  a.displayOrder - b.displayOrder;

export default displayOrderComparator;
